import { FunctionComponent } from "react";
import { observer } from "mobx-react-lite";

import { faFile, faFileCsv, faFileLines, faFilePdf, faFileWord } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useStore } from "../../../../stores/StoreContext";

import "./FileAttachments.scss";

const WELL_KNOWN_FILE_DEFINITIONS = [
  {
    extension: ".pdf",
    mimeTypes: ["application/pdf"],
    icon: faFilePdf,
  },
  {
    extension: ".docx",
    mimeTypes: ["application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
    icon: faFileWord,
  },
  {
    extension: ".txt",
    mimeTypes: ["text/plain"],
    icon: faFileLines,
  },
  {
    extension: ".md",
    mimeTypes: ["text/markdown"],
    icon: faFileLines,
  },
  {
    extension: ".html",
    mimeTypes: ["text/html"],
    icon: faFileLines,
  },
  {
    extension: ".json",
    mimeTypes: ["application/json"],
    icon: faFileLines,
  },
  {
    extension: ".csv",
    mimeTypes: ["text/csv"],
    icon: faFileCsv,
  },
  {
    extension: ".xml",
    mimeTypes: ["application/xml", "text/xml"],
    icon: faFileLines,
  },
];

const getFileIcon = (fileName: string) => {
  const extension = fileName.split(".").pop()?.toLowerCase();

  const fileDefinition = WELL_KNOWN_FILE_DEFINITIONS.find(def => def.extension === `.${extension}`);
  return fileDefinition ? fileDefinition.icon : faFile;
};

const FileAttachmentsComponent: FunctionComponent = () => {
  const { chatStore } = useStore();

  if (chatStore.selectedFiles.length === 0) {
    return null;
  }

  return (
    <div className="file-attachments">
      {chatStore.selectedFiles.map((file, index) => (
        <div key={index} className="file-chip" title={file.name}>
          <button
            type="button"
            className="file-remove"
            onClick={() => chatStore.removeSelectedFile(index)}
            aria-label={`Remove ${file.name}`}
          >
            <i className="pi pi-times" />
          </button>

          <span className="file-chip-icon" aria-hidden="true">
            <FontAwesomeIcon icon={getFileIcon(file.name)} />
          </span>

          <span className="file-name">{file.name}</span>
        </div>
      ))}
    </div>
  );
};

export const FileAttachments = observer(FileAttachmentsComponent);
